/* Audio Radar sticky add-to-cart bar.
   Loaded with defer so it doesn't block initial render.
   Product title read from data-product-title on the button. */
(function () {
  var bar = document.querySelector('[data-product-sticky-bar]');
  if (!bar) return;

  function startObserving() {
    var mainButton = document.querySelector('.purchase-details__buttons .button--add-to-cart');
    if (!mainButton) return false;
    if (!('IntersectionObserver' in window)) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 600) bar.setAttribute('data-visible', 'true');
        else bar.removeAttribute('data-visible');
      }, { passive: true });
      return true;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.removeAttribute('data-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.setAttribute('data-visible', 'true');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(mainButton);
    return true;
  }

  var tries = 0;
  function tryObserve() {
    if (startObserving()) return;
    if (++tries < 20) setTimeout(tryObserve, 200);
  }
  tryObserve();

  var btn = bar.querySelector('[data-sticky-add-to-cart]');
  if (!btn) return;

  var productTitle = btn.dataset.productTitle || 'this product';

  function setMode(mode) {
    btn.dataset.mode = mode;
    if (mode === 'checkout') {
      btn.textContent = 'Checkout';
      btn.setAttribute('aria-label', 'Go to checkout');
    } else {
      btn.textContent = 'Add to Cart';
      btn.setAttribute('aria-label', 'Add ' + productTitle + ' to cart');
    }
  }

  document.addEventListener('audioradar:cart-updated', function (e) {
    if (btn.dataset.state === 'adding' || btn.dataset.state === 'added') return;
    var count = (e.detail && e.detail.item_count) || 0;
    setMode(count > 0 ? 'checkout' : 'add');
  });

  if (typeof window.__audioRadarCartWatcher === 'function') {
    window.__audioRadarCartWatcher();
  } else {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setMode((cart.item_count || 0) > 0 ? 'checkout' : 'add'); })
      .catch(function () {});
  }

  btn.addEventListener('click', function () {
    if (btn.disabled) return;

    if (btn.dataset.mode === 'checkout') {
      window.location.href = '/checkout';
      return;
    }

    var variantId = String(btn.dataset.variantId).match(/(\d+)$/);
    variantId = variantId ? variantId[1] : btn.dataset.variantId;
    btn.disabled = true;
    btn.dataset.state = 'adding';
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || ('HTTP ' + res.status));
          return data;
        });
      })
      .then(function () {
        try {
          if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
            window.PXUTheme.jsAjaxCart.updateView();
          }
        } catch (e) {}
        btn.dataset.state = 'added';
        btn.textContent = '✓ Added';
        setTimeout(function () {
          btn.dataset.state = '';
          btn.disabled = false;
          setMode('checkout');
          if (typeof window.__audioRadarCartWatcher === 'function') {
            window.__audioRadarCartWatcher();
          }
        }, 1200);
      })
      .catch(function (err) {
        console.error('[sticky-bar]', err);
        btn.dataset.state = '';
        btn.textContent = 'Try again';
        setTimeout(function () {
          btn.disabled = false;
          setMode('add');
        }, 2000);
      });
  });
})();
